import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Soleil = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 81.59 81.59">
  <G fill={color}>
    <Path d="M40.8,15.86c-13.72,0-24.84,11.12-24.84,24.84s11.12,24.84,24.84,24.84,24.84-11.12,24.84-24.84-11.12-24.84-24.84-24.84ZM37.19,30.62c-3.25,1.16-5.76,3.84-6.69,7.16-.35,1.22-1.46,2.02-2.67,2.02-.25,0-.5-.03-.76-.11-1.47-.42-2.33-1.95-1.91-3.43,1.43-5.04,5.23-9.11,10.17-10.87,1.45-.51,3.03.24,3.55,1.68.52,1.44-.24,3.03-1.68,3.55Z"/>
    <Path d="M40.8,69.36c-1.53,0-2.78,1.24-2.78,2.78v6.68c0,1.53,1.24,2.78,2.78,2.78s2.78-1.24,2.78-2.78v-6.68c0-1.53-1.24-2.78-2.78-2.78Z"/>
    <Path d="M40.8,12.23c1.53,0,2.78-1.24,2.78-2.78V2.78c0-1.53-1.24-2.78-2.78-2.78s-2.78,1.24-2.78,2.78v6.68c0,1.53,1.24,2.78,2.78,2.78Z"/>
    <Path d="M12.23,40.8c0-1.53-1.24-2.78-2.78-2.78H2.78c-1.53,0-2.78,1.24-2.78,2.78s1.24,2.78,2.78,2.78h6.68c1.53,0,2.78-1.24,2.78-2.78Z"/>
    <Path d="M78.82,38.02h-6.68c-1.53,0-2.78,1.24-2.78,2.78s1.24,2.78,2.78,2.78h6.68c1.53,0,2.78-1.24,2.78-2.78s-1.24-2.78-2.78-2.78Z"/>
    <Path d="M16.67,61l-4.72,4.72c-1.08,1.08-1.08,2.84,0,3.92.54.54,1.25.81,1.96.81s1.42-.27,1.96-.81l4.72-4.72c1.08-1.08,1.08-2.84,0-3.92-1.08-1.08-2.84-1.08-3.92,0Z"/>
    <Path d="M62.96,21.41c.71,0,1.42-.27,1.96-.81l4.72-4.72c1.08-1.08,1.08-2.84,0-3.92-1.08-1.08-2.84-1.08-3.92,0l-4.72,4.72c-1.08,1.08-1.08,2.84,0,3.92.54.54,1.25.81,1.96.81Z"/>
    <Path d="M16.67,20.6c.54.54,1.25.81,1.96.81s1.42-.27,1.96-.81c1.08-1.08,1.08-2.84,0-3.92l-4.72-4.72c-1.08-1.08-2.84-1.08-3.92,0-1.08,1.08-1.08,2.84,0,3.92l4.72,4.72Z"/>
    <Path d="M64.92,61c-1.08-1.08-2.84-1.08-3.92,0-1.08,1.08-1.08,2.84,0,3.92l4.72,4.72c.54.54,1.25.81,1.96.81s1.42-.27,1.96-.81c1.08-1.08,1.08-2.84,0-3.92l-4.72-4.72Z"/>
  </G>
</Svg>
);
};

export default Soleil;
